import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { collection, getDocs, getFirestore } from "firebase/firestore"
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { Box, Button, Paper, Typography, InputLabel, MenuItem, FormControl, Grid } from '@mui/material'
import DeleteForeverSharpIcon from '@mui/icons-material/DeleteForeverSharp'
import { firestore } from '../Firebase/utils'
import ConfirmDeleteUser from '../Components/ConfirmDeleteUser'
import Select from '@mui/material/Select'
import { styled } from '@mui/material/styles'
import AddResourceModal from '../Components/AddResourceModal'
import { useNavigate } from 'react-router-dom'
import { setStudentData } from '../Redux/User/user.actions'

export default function Admin() {
    const [users, setUsers] = useState([])
    const [userDeleteOpen, setUserDeleteOpen] = React.useState(false);
    const [AddResourceModalOpen, setAddResourceModalOpen] = useState(false)
    const [selectedValue, setSelectedValue] = React.useState();
    const [student, setStudent] = useState(null)
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const fetchAllUsers = async () => {
        const querySnapshot = await getDocs(collection(getFirestore(), "users"))
        setUsers(querySnapshot.docs)
    };

    useEffect(() => {
        fetchAllUsers()
        return setStudent(null)
    }, [])

    const handleUserDeleteClickOpen = id => {
            setUserDeleteOpen(true)
      };
    
      const handleUserDeleteClose = value => {
        setUserDeleteOpen(false);
        setSelectedValue(value);
      };

      const handleAddResourceModalClose = () => {
        setAddResourceModalOpen(false)
      }

      const BootstrapButton = styled(Button)({
        backgroundColor: '#000',
        marginLeft: 40
      })
    
    

  return (
    <Grid container display='flex' direction='row' justifyContent='center' position='relative' sx={{backgroundColor:'#181824', pt:1, maxHeight:'100vh'}}>
          <Grid item container justifyContent='center'> 
             <Typography variant='h5' color='#FFF' fontSize={25} fontWeight='bold'>ADMIN</Typography>
         </Grid>
         <Grid item container justifyContent='left'><BootstrapButton onClick={() => {setAddResourceModalOpen(true)}}>Add Resource</BootstrapButton></Grid>
         <Grid container direction='row' sx={{width: '100%', height: '80vh', overflowY:'auto'}}>
         <TableContainer component={Paper} sx={{width:'100%', overflow:'auto'}}>
            <Table sx={{ minWidth: 650, backgroundColor:'#181824'}} size="small">
                <TableHead>
                    <TableRow>
                        <TableCell><Typography color='white' fontWeight='bold'>Name</Typography></TableCell>
                        <TableCell><Typography color='white' fontWeight='bold'>Email</Typography></TableCell>
                        <TableCell><Typography color='white' fontWeight='bold'></Typography></TableCell>
                        <TableCell><Typography color='white' fontWeight='bold'>User Role</Typography></TableCell>
                        <TableCell><Typography color='white' fontWeight='bold'>Date Created</Typography></TableCell>
                        <TableCell><Typography color='white' fontWeight='bold'>Delete</Typography></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {users.map((user, index) => {
                        const date = new Date(user.data().createdDate.seconds * 1000)
                        return(
                        <TableRow key={index}  sx={{ "&:hover":{color:'#0FF', backgroundColor:'#555'}}}>
                            <TableCell>
                                <Typography color='#36BAFE'>{user.data().firstName ? `${user.data().firstName} ${user.data().lastName}` : user.data().displayName ? user.data().displayName : 'NO NAME WAS ENTERED'}</Typography>
                            </TableCell>
                            <TableCell>
                                <Typography color='#36BAFE'>{user.data().email}</Typography>
                            </TableCell>
                            <TableCell>
                                <BootstrapButton onClick={() => {  setStudent(user); dispatch(setStudentData(user)); navigate('/admin-chat')}}>OPEN CHAT</BootstrapButton>
                            </TableCell>
                            <TableCell>
                                <BasicSelect role={user.data().userRoles[0]} documentID={user.id}/>
                            </TableCell>
                            <TableCell>
                                <Typography color='#36BAFE'>{date.toDateString()}</Typography>
                            </TableCell>
                            <TableCell>
                                <DeleteForeverSharpIcon size='large' sx={{ color:'#F00', "&:hover":{color:'#F00', backgroundColor:'#555', cursor:'pointer'}}}  onClick={() => {setSelectedValue(user); handleUserDeleteClickOpen(user.id)}}/>
                            </TableCell>
                        </TableRow>
                        )
                    })}
                </TableBody>
            </Table>
        </TableContainer>
         </Grid>
         {selectedValue ? <ConfirmDeleteUser
                selectedValue={selectedValue}
                open={userDeleteOpen}
                onClose={handleUserDeleteClose}
            /> : null}
        <AddResourceModal 
            open={AddResourceModalOpen}
            onClose={handleAddResourceModalClose}
        />
    </Grid>
  )
}

function BasicSelect(props) {
    const [role, setRole] = React.useState('');
  
    const handleChange = (e) => {
        setRole(e.target.value);
    };

    useEffect(() => {
        setRole(props.role)
    }, [])
  
    return (
      <Box sx={{ minWidth: 120 }}>
        <FormControl fullWidth>
          <InputLabel id="select-label" sx={{color: '#36BAFE', '&.Mui-focused': {color:'#36BAFE'} }}>Role</InputLabel>
          <Select
            labelId="simple-select-label"
            id="simple-select"
            value={role}
            label="Age"
            onChange={handleChange}
            size='small'
            sx={{
                color: "#36BAFE",
                '.MuiOutlinedInput-notchedOutline': {
                  borderColor: '#36BAFE',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#36BAFE',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#36BAFE',
                },
                '.MuiSvgIcon-root ': {
                  fill: "#36BAFE !important",
                }
              }}
          >
            <MenuItem value={'superAdmin'}>Super Admin</MenuItem>
            <MenuItem value={'admin'}>Admin</MenuItem>
            <MenuItem value={'student'}>Student</MenuItem>
            <MenuItem value={'stakeHolder'}>StakeHolder</MenuItem>
            <MenuItem value={'user'}>User</MenuItem>
          </Select>
        </FormControl>
      </Box>
    );
  }